<template>

  <div v-if="comp">
    <component :is="comp" v-bind="{stats: getStats()}" />
  </div>

</template>

<script>

import BackhaulView from '@/components/views/BackhaulView'
import ContractorView from '@/components/views/ContractorView'
import LandlordView from '@/components/views/LandlordView'
import TelcoView from '@/components/views/TelcoView'
import TowerView from '@/components/views/TowerView'
import TowerSupplierView from '@/components/views/TowerSupplierView'

export default {

  methods: {

    view (category) {

      switch (category) {
          case 'Backhaul': return BackhaulView
          case 'Contractor': return ContractorView
          case 'Landlord': return LandlordView
          case 'Telco': return TelcoView
          case 'Tower Company': return TowerView
          case 'Tower Supplier': return TowerSupplierView
          default: return null

      }

    }
  },


  watch: {

    stats: function (s) {
      this.stats = s
    }

  },


  data () {
    return {
      comp: null,
      stats: null
    }
  },

  created () {
    this.stats = this.getStats(this.org().id, true)
    this.comp = this.view(this.profile().orgCategory)
  }

}
</script>
